module.exports = __webpack_public_path__ + "eg.4263356b4f839970c2b6.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/eg.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/eg.svg
// module chunks = styles